import React, { useState, useMemo } from "react";
import { Card } from "react-bootstrap";
import { useSelector } from "react-redux";
import { ClassContentDiscussionResponse } from "../../services/api.response.service";
import { IRootState } from "../../redux/states";
import Discussions from "./Disccussions";

export type DiscussFilter = "current_topic" | "all_classes";
export type DiscussSortBy = "recommended" | "recent";

interface CourseContentDiscussProps {
  discussions: ClassContentDiscussionResponse[];
  contentID: string | number;
  onPostSuccess?: () => void;
  discussFilter: DiscussFilter;
  onDiscussFilterChange: (value: DiscussFilter) => void;
  /** When true, show filter row even if the list is empty */
  showDiscussFilters?: boolean;
}

const filterOptions: { value: DiscussFilter; label: string }[] = [
  { value: "current_topic", label: "Current Topic" },
  { value: "all_classes", label: "All Classes" },
];

function CourseContentDiscuss({
  discussions,
  contentID,
  onPostSuccess,
  discussFilter,
  onDiscussFilterChange,
  showDiscussFilters = false,
}: CourseContentDiscussProps) {
  const { user } = useSelector((state: IRootState) => state.setting);
  const [searchQuery, setSearchQuery] = useState("");

  const filteredDiscussions = useMemo(() => {
    let list = [...discussions];
    const q = searchQuery.trim().toLowerCase();
    if (q) {
      list = list.filter(
        (d) =>
          d.post?.toLowerCase().includes(q) ||
          d.user?.name?.toLowerCase().includes(q),
      );
    }

    return list;
  }, [discussions, searchQuery, user?.id]);

  return (
    <div>
      {(showDiscussFilters || discussions.length > 0) && (
        <div className="p-3 d-flex flex-column gap-3 mb-0">
          {/* <div className="discuss-search-input">
            <i
              className="las la-search discuss-search-input__icon"
              aria-hidden
            />
            <input
              type="search"
              className="discuss-search-input__field"
              placeholder="Search all questions"
              aria-label="Search discussions"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div> */}
          <div className="discuss-filters-row">
            <div className="discuss-filters-row__group">
              <span className="discuss-filters-row__label">Filters:</span>
              <select
                className="discuss-filters-row__select"
                value={discussFilter}
                onChange={(e) =>
                  onDiscussFilterChange(e.target.value as DiscussFilter)
                }
                aria-label="Filter discussions"
              >
                {filterOptions.map(({ value, label }) => (
                  <option key={value} value={value}>
                    {label}
                  </option>
                ))}
              </select>
            </div>

            <button type="button" className="discuss-filters-row__btn">
              Filter questions
            </button>
          </div>
        </div>
      )}
      <Card className="discussCard position-relative" id="discuss">
        <Discussions
          discussions={filteredDiscussions}
          contentID={contentID}
          hasAnyDiscussions={discussions.length > 0}
          onPostSuccess={onPostSuccess}
        />
      </Card>
    </div>
  );
}

export default CourseContentDiscuss;
